import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    dragIconWrapper: {
        height: "56px",
        width: "68px",
        margin: `${theme.spacing(1)} ${theme.spacing(6)} 0 0`,
        color: `black`,
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "10%",
        padding: "4px",
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        cursor: "pointer",
        transition: "all 0.3s ease",
    },
    dragIconWrapperActive: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.text.primary,
        boxShadow: `0px 4px 8px ${theme.palette.primary.main}40, 0px 2px 0px rgba(62, 93, 138, 0.4)`,
        transform: "scale(1.05)",
        border: `2px solid ${theme.palette.primary.dark}`,
    },
    dragIconWrapperDisabled: {
        opacity: 0.5,
        cursor: "not-allowed",
        pointerEvents: "none",
    },
}));
